import getEnv from './get-env';
import getConfig from './get-config';

/**
 * Builds an InfoHub URL for the current environment.
 * Non-prod (local/dev/stage) uses staging InfoHub; prod uses production.
 *
 * @param {string} [path=''] Path after the base URL, with or without a leading slash
 * @returns {string}
 */
const getInfoHubUrl = (path = '') => {
  const base = getConfig(getEnv(window.location.hostname)).infoHubBaseUrl.replace(/\/$/, '');
  if (!path) {
    return `${base}/`;
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};

export default getInfoHubUrl;
